import React from 'react';
import Scrollspy from 'react-scrollspy';
import Scroll from './components/Scroll';
import MaterialIcon from 'material-icons-react';
import { NavLink } from 'react-router-dom';
import strings from './components/language/language';
import { withStyles } from '@material-ui/core/styles';
import {
  Menu,
  MenuItem,
  Button,
  AppBar,
  Toolbar,
  Hidden,
} from '@material-ui/core';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import SearchBar from './SearchBar';
import ExpandMore from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';

import './App.css';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    textDecoration: 'none',
  },

  tabsIndicator: {
    backgroundColor: '#70142C',
    height: '5px',
    borderRadius: '25px',
  },
  tabRoot: {
    color: 'black',
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightMedium,
    marginRight: 10,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#d4315b',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#70142C',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#70142C',
      backgroundColor: 'white',
    },
  },
  tabSelected: {},
  tabLabel: {
    fontSize: '16px',
  },
  tabLabelContainer: {
    '&:focus': {
      color: '#70142C',
    },
  },
  buttonTab: {
    fontFamily: 'Segoe UI',
    // padding: '10px 15px',
    margin: '0 10px',
    textTransform: 'capitalize',
    borderBottom: '5px solid #70142b',
    borderBottomRightRadius: '0 !important',
    borderBottomLeftRadius: '0 !important',
    position: 'relative',
    bottom: -5,
    [theme.breakpoints.down('sm')]: {
      padding: '8px 0',
    },
  },
  buttonUnTabbed: {
    borderBottomRightRadius: '0 !important',
    borderBottomLeftRadius: '0 !important',
    fontFamily: 'Segoe UI',
    // padding: '10px 15px',
    margin: '0 10px',
    textTransform: 'capitalize',
    borderRadius: 0,
    position: 'relative',
    bottom: -5,
    [theme.breakpoints.down('sm')]: {
      padding: '8px 0',
    },
  },
  linkTab: {
    textDecoration: 'none',
    color: '#70142b',
    fontWeight: 'bold',
    fontSize: 16,
  },
  linkUnTabbed: {
    textDecoration: 'none',
    color: '#000',
    fontWeight: 'bold',
    fontSize: 16,
  },
  logo: {
    position: 'absolute',
    bottom: 0,
    width: 60,
    borderRadius: 5,
    marginRight: 30,
    [theme.breakpoints.down('sm')]: {
      marginRight: 10,
      position: 'relative',
      top: 17,
    },
  },
  // dropDown: {
  //   [theme.breakpoints.down('md')]: {
  //     marginTop: 10
  //   }
  // }
});

class ScrollNav extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.dropDown = React.createRef();
  }
  state = {
    selectedButton: null,
    anchorEl: null,
    text: null,
    // query: '',
    fullWidth: false,
    clearIcon: false,
    value: 0,
    anchorEl: null,
    tab: 0,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  expand = () => {
    this.setState({
      fullWidth: true,
    });
  };

  clear = () => {
    this.setState({
      text: '',
    });
  };
  queryChange = (evt) => {
    // console.log('TESTAWY' + evt.target.value);
    this.setState({ query: evt.target.value });
  };

  componentDidMount() {
    this.setState({ Scrollspy: this.props.categories[0] });
  }
  scrollspyHandler = () => {
    let index = this.myRef.current.state.inViewState.indexOf(true);
    if (index !== -1) {
      let temp = this.myRef.current.props.items[index];
      this.setState({ Scrollspy: temp });
    }
  };
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { anchorEl, value } = this.state;
    const { classes, info, logo } = this.props;
    console.log('LOGO', logo);
    // let Tabanchors = (this.props.categories.map((category, index) => {
    //   return (
    //     <Scroll type="id" element={category}>
    //       <Tab
    //         classes={{ root: classes.tabRoot, selected: classes.tabSelected, label: classes.tabLabel, labelContainer: classes.tabLabelContainer }}
    //         href={"#" + category}
    //         key={index}
    //         label={category}
    //       />
    //     </Scroll>
    //   )
    // }
    // ));

    let anchors = this.props.categories.map((category, index) => {
      return (
        <Scroll type='id' element={category}>
          <a href={'#' + category} style={{ textDecoration: 'none' }}>
            <MenuItem
              id='menu-item'
              onClick={this.handleClose}
              style={{ textDecoration: 'none' }}
              key={index}
            >
              {category}{' '}
            </MenuItem>
          </a>
        </Scroll>
      );
    });

    return (
      <div>
        {/* <div className="navbar-fixed">
          <nav>
            <div className="nav-wrapper">
              <div className="row">
                <ul className="center "> */}
        {/* <li className="col s12"><Dropdown  options={{hover:false}}  trigger={<a>   
                    <span className="nav-icon">
                    <MaterialIcon   icon="arrow_drop_down" size={30} color='#FFF' />
                    </span>
                    {this.state.Scrollspy} </a> }>
                    <Scrollspy items={this.props.categories } onUpdate={this.scrollspyHandler} currentClassName="is-current" ref={this.myRef} >
                    {anchors }
                    
                    </Scrollspy>
                   </Dropdown></li> */}
        {/* <li className="col s12"> */}
        {/* mobile nabvar */}
        {/* <Hidden mdUp> */}
        <div id='main-div>' className={classes.root}>
          <AppBar query={this.state.query} id='appbar'>
            <Toolbar id='toolbar' style={{ backgroundColor: this.props.color }}>
              <Grid container style={{ marginTop: 7 }}>
                <Grid item xs={8} style={{ position: 'relative' }}>
                  <SearchBar
                    queryChange={this.props.queryChange}
                    query={this.props.query}
                    clear={this.props.clear}
                  />
                  {/* <TextField
                      onClick={this.expand}

                      // fullWidth
                      variant='outlined'
                      className={classNames(classes.margin, classes.textField, classes.textRoot)}
                      placeholder="search for items"
                      value={this.props.query}
                      onChange={this.props.queryChange}
                      id="input-with-icon-textfield"
                      InputProps={{
                        variant: "outlined",
                        disableUnderline: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon style={{ position: 'relative', left: '8px' }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment variant="filled" position="end">
                            <CloseIcon style={{ fontSize: '17', position: 'relative', right: '4px' }} onClick={this.props.clear} />
                          </InputAdornment>
                        ),

                      }}
                    /> */}
                </Grid>
                <Grid item xs={4} style={{ position: 'relative', top: 57 }}>
                  {/* <NavLink className="navlink" to="/history"><HistoryIcon style={{'marginLeft':'10px', 'fontSize':'27px', 'vertical-align': 'text-bottom'}}/></NavLink> */}
                  <NavLink className='navlink' to='/history'>
                    <div className={classNames(classes.margin, 'right-align ')}>
                      <Button
                        className='edit-order-button'
                        title='Reorder'
                        variant='outlined'
                        style={{
                          padding: '0 25px',
                        }}
                      >
                        {strings.orders}
                      </Button>
                    </div>
                  </NavLink>
                </Grid>
              </Grid>
              <Button
                id='scrollspy-button'
                onClick={this.handleClick}
                fullWidth={true}
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  height: '100%',
                }}
              >
                {this.state.Scrollspy}
                <span className='nav-icon'>
                  <MaterialIcon icon='arrow_drop_down' size={30} color='#FFF' />
                </span>
              </Button>

              <Scrollspy
                offset={200}
                items={this.props.categories}
                onUpdate={this.scrollspyHandler}
                currentClassName='is-current'
                ref={this.myRef}
              >
                <Menu
                  id='simple-menu'
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                  style={{ display: 'none' }}
                >
                  {anchors}
                </Menu>

                {/* <div id="hidden-sidenav">
                    <MenuList id="list-sidenav"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={this.handleClose}>
                    {anchors }
                    
                    </MenuList>
                    
                    </div> */}
              </Scrollspy>
            </Toolbar>
          </AppBar>
        </div>
        {/* </Hidden> */}
        {/* mobile nabvar */}
        {/* desktop nabar */}
        {/* <Hidden smDown> */}
        <Scrollspy
          offset={200}
          items={this.props.categories}
          onUpdate={this.scrollspyHandler}
          currentClassName='is-current'
          ref={this.myRef}
        >
          {/* <Tabs
              classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
              // scrollable={true}
              value={value}
              onChange={this.handleChange}
              indicatorColor="secondary"
              textColor="primary"
              variant="scrollable"
              component="div"
            // scrollButtons="auto"
            >
              {Tabanchors[0]}
              {Tabanchors[1]}
              {Tabanchors[2]}
              {Tabanchors[3]}
              <IconButton
                aria-owns={anchorEl ? 'simple-menu' : undefined}
                aria-haspopup="true"
                onClick={this.handleClick}>
                <ExpandMore />
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
                MenuListProps={{
                  style: {
                    padding: 0
                  }
                }}
              >
                <div style={{ width: '350px' }} onClick={this.handleClose}>{anchors}</div>
              </Menu>
            </Tabs> */}
          {/* Restaurant's logo */}
          <img
            src={logo ? logo.logoUrlRestaurant : null}
            className={classNames(classes.logo, 'image-facebook')}
            alt='logo'
          />
          {/* Restaurant's logo */}
          {/* Start of tabs */}
          <Button
            onClick={() => this.setState({ tab: 0 })}
            className={
              this.state.tab === 0 ? classes.buttonTab : classes.buttonUnTabbed
            }
            style={{
              marginLeft: 105,
              borderBottom:
                this.state.tab === 0 ? `5px solid ${this.props.color}` : 'none',
            }}
          >
            <Scroll type='id' element={this.props.categories[0]}>
              <a
                href='#'
                className={
                  this.state.tab === 0 ? classes.linkTab : classes.linkUnTabbed
                }
                style={{
                  color: this.state.tab === 0 ? this.props.color : '#000',
                }}
              >
                {this.props.categories[0]}
              </a>
            </Scroll>
          </Button>
          <Button
            onClick={() => this.setState({ tab: 1 })}
            className={
              this.state.tab === 1 ? classes.buttonTab : classes.buttonUnTabbed
            }
            style={{
              borderBottom:
                this.state.tab === 1 ? `5px solid ${this.props.color}` : 'none',
            }}
          >
            <Scroll type='id' element={this.props.categories[1]}>
              <a
                href='#'
                className={
                  this.state.tab === 1 ? classes.linkTab : classes.linkUnTabbed
                }
                style={{
                  color: this.state.tab === 1 ? this.props.color : '#000',
                }}
              >
                {this.props.categories[1]}
              </a>
            </Scroll>
          </Button>
          <Button
            onClick={() => this.setState({ tab: 2 })}
            className={classNames(
              this.state.tab === 2 ? classes.buttonTab : classes.buttonUnTabbed,
              'menu-tab-facebook'
            )}
            style={{
              borderBottom:
                this.state.tab === 2 ? `5px solid ${this.props.color}` : 'none',
            }}
          >
            <Scroll type='id' element={this.props.categories[2]}>
              <a
                href='#'
                className={
                  this.state.tab === 2 ? classes.linkTab : classes.linkUnTabbed
                }
                style={{
                  color: this.state.tab === 2 ? this.props.color : '#000',
                }}
              >
                {this.props.categories[2]}
              </a>
            </Scroll>
          </Button>

          <Button
            onClick={() => this.setState({ tab: 3 })}
            className={classNames(
              this.state.tab === 3 ? classes.buttonTab : classes.buttonUnTabbed,
              'menu-tab-facebook'
            )}
            style={{
              borderBottom:
                this.state.tab === 3 ? `5px solid ${this.props.color}` : 'none',
            }}
          >
            <Scroll type='id' element={this.props.categories[3]}>
              <a
                href='#'
                className={
                  this.state.tab === 3 ? classes.linkTab : classes.linkUnTabbed
                }
                style={{
                  color: this.state.tab === 3 ? this.props.color : '#000',
                }}
              >
                {this.props.categories[3]}
              </a>
            </Scroll>
          </Button>
          {/* End of tabs */}
          <IconButton
            aria-owns={anchorEl ? 'simple-menu' : undefined}
            aria-haspopup='true'
            onClick={this.handleClick}
            className={classes.dropDown}
          >
            <ExpandMore />
          </IconButton>
          <Menu
            id='simple-menu'
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            MenuListProps={{
              style: {
                padding: 0,
              },
            }}
          >
            <div style={{ width: '350px' }} onClick={this.handleClose}>
              {anchors}
            </div>
          </Menu>
        </Scrollspy>
        {/* </Hidden> */}
        {/* desktop nabar */}

        {/* <div id="hidden-div">
                    
                    <Toolbar id="toolbar">
                    <Button id="scrollspy-button"  style={{ textDecoration: 'none' ,color: 'inherit',height:"100%"}}/>
                    
                    <Scrollspy items={this.props.categories } onUpdate={this.scrollspyHandler} currentClassName="is-current" ref={this.myRef} >

                    <div id="hidden-sidenav">
                    <MenuList id="list-sidenav"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={this.handleClose}>
                      {anchors }
                     </MenuList>
                    </div>
                    </Scrollspy>
                    </Toolbar>
                    </div> */}

        {/* </li> */}

        {/* </ul>
              </div>
            </div>
          </nav>
        </div> */}
        {/* <ul id="dropdown1" class="dropdown-content">
          <Scrollspy items={this.props.categories } onUpdate={this.scrollspyHandler} currentClassName="is-current" ref={this.myRef} >
                    {anchors }
                    
                    </Scrollspy>
          </ul>
         <div> 
          <nav>
            <div className="nav-wrapper">
              <div className="row">
                <ul className="center">
                  <li className="col s12"> <a className="dropdown-trigger" href="#!" data-target="dropdown1"><span className="nav-icon">
                    <MaterialIcon   icon="arrow_drop_down" size={30} color='#FFF' />
                    </span>
                    {this.state.Scrollspy}</a>
                  </li>
                </ul>
               </div>
             </div>
            </nav>
          </div> */}
      </div>
    );
  }
}

export default withStyles(styles)(ScrollNav);



// WEBPACK FOOTER //
// ./src/Scrollspy.js